import React from 'react'
import PropTypes from 'prop-types'

import QuoteSectionWrapper from 'agency/digital_renderer/components/QuoteSectionWrapper'

import QuoteItem from './QuoteItem'
import styles from './styles.scss'

const QuoteSection = (props) => {
  const { campaignQuoteSection } = props

  return (
    <QuoteSectionWrapper
      campaignQuoteSection={campaignQuoteSection}
      render={({
        hidePrices, quoteItems, showSubtotal, formattedSubtotal,
      }) => (
        <div className={styles.root}>
          <div className={styles.header}>
            <h3>{campaignQuoteSection.title}</h3>
            {showSubtotal && formattedSubtotal && <span className={styles.subtotal}>{formattedSubtotal}</span>}
          </div>

          <ul className={styles.items}>
            {quoteItems.map(item => <QuoteItem key={item.id} campaignQuoteItem={item} showPrice={!hidePrices} />)}
          </ul>
        </div>
      )}
    />
  )
}

QuoteSection.propTypes = {
  campaignQuoteSection: PropTypes.object.isRequired,
}

export default QuoteSection
